<template>
  <div
    :class="['panel-sidebar', { 'panel-sidebar--active': navBarMobileVisible }]"
  >
    <div class="top-nav">
      <mq-layout :mq="['break-xs', 'break-small']">
        <el-button
          class="mobile-nav__button"
          icon="ion ion-android-menu"
          @click="toggleNavBarMobile()"
        />
      </mq-layout>

      <div class="logo">
        <a :href="LANDING_URL">
          <img
            v-show="!sidebarCollapsed"
            alt="vestbee"
            :src="STATIC_URL + 'images/vestbee_logo_white.png'"
            width="96"
          />
          <img
            v-show="sidebarCollapsed"
            :src="STATIC_URL + 'images/vestbee_sm_logo_white.png'"
            width="30"
          />
        </a>
      </div>
      <div class="nav-collapsers">
        <i v-show="!sidebarCollapsed" @click="collapseNavBar()">
          <ion-icon name="chevron-back" />
        </i>
        <i v-show="sidebarCollapsed" @click="expandNavBar()">
          <ion-icon name="chevron-forward" />
        </i>
      </div>
    </div>
    <div class="nav-menu">
      <slot />
    </div>
    <div class="user-menu">
      <el-dropdown placement="top-end" trigger="click">
        <el-button type="primary" class="dropdown-button">
          <span class="account">Account</span>
          <span class="ion ion-person pull-right"></span>
        </el-button>
        <el-dropdown-menu slot="dropdown" class="user-menu-dropdown-old">
          <el-dropdown-item class="dropdown-item-with-link">
            <router-link :to="{ name: 'changePasswordPage' }">
              Change password
            </router-link>
          </el-dropdown-item>
          <el-dropdown-item class="dropdown-item-with-link">
            <a href @click.prevent="logout()">Logout</a>
          </el-dropdown-item>
          <el-dropdown-item divided>
            <CopyClick :text="user.email" placement="right">
              <span class="username">{{ user.email }}</span>
            </CopyClick>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import GlobalSettings from '../../GlobalSettings'
import CopyClick from 'components/CopyClick'

export default {
  components: {
    CopyClick,
  },
  computed: mapState({
    LANDING_URL: () => GlobalSettings.LANDING_URL,
    user: (state) => state.user.data || {},
    sidebarCollapsed: (state) => state.common.sidebarCollapsed,
    navBarMobileVisible: (state) => state.common.navBarMobileVisible,
  }),
  data: () => ({
    STATIC_URL: GlobalSettings.STATIC_URL,
    followedCountChanged: false,
  }),
  methods: {
    ...mapMutations({
      setNavBarMobileVisibility: 'common/TOGGLE_NAV_BAR_MOBILE',
    }),
    logout() {
      this.$router.push({ name: 'logout' })
    },
    collapseNavBar() {
      this.$store.commit('common/COLLAPSE_SIDEBAR')
    },
    expandNavBar() {
      this.$store.commit('common/EXTEND_SIDEBAR')
    },
    toggleNavBarMobile() {
      this.setNavBarMobileVisibility()
    },
  },
}
</script>

<style lang="scss">
@import '~assets/css/colors.scss';
@import '~assets/css/vars.scss';

.username {
  padding: 0px 14px;
  font-size: 14px;
  color: #999999;
}

.top-nav {
  display: flex;
  padding: 0px 14px;
  background: $grey30;

  .logo {
    margin-right: 14px;
  }

  a {
    margin-right: 28px;

    @apply flex items-center self-center;
  }

  i {
    color: $white;
    align-self: center;
    cursor: pointer;
  }
}

.panel-sidebar {
  .nav {
    span.ion,
    ion-icon {
      width: 32px;
      text-align: center;
    }
  }
}

#app.sidebar-collapsed {
  $collapsed-sidebar-width: 54px;

  .panel-sidebar {
    width: $collapsed-sidebar-width;

    .top-nav {
      padding: 0 6px;

      .logo {
        margin-right: 0;
        flex-grow: 1;
      }

      a {
        margin-right: 4px;
      }
    }

    .nav {
      li a {
        padding-left: 12px;
        padding-right: 12px;
      }

      .title {
        display: none;
      }
    }

    .nav-collapsers {
      margin-top: 2px;
    }

    .user-menu {
      margin-left: -80px;
    }

    .dropdown-menu {
      margin-left: 80px;
    }
  }

  .panel-content {
    margin-left: $collapsed-sidebar-width;

    .panel-topnav {
      position: fixed;
      top: 0;
      left: $collapsed-sidebar-width;
      right: 0;
      min-height: 64px;
      background: $white;
      box-shadow: 0px 6px 8px rgba(0, 0, 0, 0.05);
      z-index: 300;

      .panel-controls {
        height: 66px;
        padding: 12px 24px 0;
        border-right: 1px solid $grey180;
      }

      .back-link {
        line-height: 66px;
        padding: 0 30px;
        border-right: 1px solid $grey180;

        &:hover,
        &:focus,
        &:active {
          text-decoration: none;
        }
      }
    }
  }
}

@media screen and (max-width: theme('screens.sm')) {
  .panel-content {
    .panel-topnav {
      background: $grey30;
      height: 65px;
      box-shadow: none;

      .back-link {
        border-right: none;
      }
    }

    .nav-tabs {
      margin: 4px auto;
    }
  }

  .mobile-nav__button {
    background: $grey30;
    border: none;

    i {
      font-size: 30px;
    }

    &:hover {
      background: $grey30;
      border: none;
    }

    &:focus {
      background: $grey30;
    }
  }

  .panel-sidebar {
    height: 65px;
    width: unset;

    .top-nav {
      height: 65px;

      .logo {
        width: 96px;
      }
    }

    z-index: 1000;
    background: none;

    .nav-collapsers {
      display: none;
    }

    .nav-menu {
      display: none;
    }

    .user-menu {
      display: none;
    }
  }

  .panel-sidebar--active {
    background: $grey30;
    width: 100vw;
    z-index: 1002;
    height: 100vh;

    .nav-menu {
      display: initial;
    }

    .user-menu {
      display: initial;
    }
  }
}

.panel-sidebar {
  .user-menu .el-dropdown {
    width: 100%;
    position: absolute;
    bottom: 0;

    .dropdown-button {
      width: 100%;
      padding-right: 25px;

      > span {
        display: inline;
      }
    }
  }

  .nav-menu {
    overflow: auto;
    height: 80vh;
  }
}

#app.sidebar-collapsed {
  .panel-sidebar {
    .user-menu .el-dropdown {
      .dropdown-button {
        .account {
          display: none;
        }
        padding-right: 18px;
      }
    }
  }
}
</style>

<style lang="scss">
.user-menu-dropdown-old {
  @apply bg-white;

  .dropdown-item-with-link {
    padding: 0;
    a {
      padding: 0 20px;
      display: block;
    }
  }

  .popper__arrow {
    @apply border-t-white #{!important};

    &::after {
      @apply border-t-white #{!important};
    }
  }
}
</style>
